import FilesService from 'src/services/files'

export default {
  createFile (payload) {
    const promise = FilesService.createNewFile(payload)

    return promise
  },
  createMasssiveFile (payload) {
    const promise = FilesService.createMassiveNewFile(payload)

    return promise
  },
  updateFileResources (payload) {
    const promise = FilesService.updateNewFileResources(payload)

    return promise
  },
  updateFile (payload) {
    const promise = FilesService.updateNewFile(payload)

    return promise
  },
  filesAll () {
    const promise = FilesService.all()

    promise.then(data => {
      this.files = data
    })

    return promise
  },
  filesbyFolder (id) {
    const promise = FilesService.byFolder(id)

    promise.then(data => {
      this.files = data
    })

    return promise
  },
  deleteFile (folder_id) {
    const promise = FilesService.delete(folder_id)

    return promise
  },
  getFrachises () {
    const promise = FilesService.getFrachises()

    promise.then(data => {
      this.frachises = data
    })

    return promise
  },
  getLocations () {
    const promise = FilesService.getLocations()

    promise.then(data => {
      this.locations = data
    })

    return promise
  },
  getRoleUsers () {
    const promise = FilesService.getRoleUsers()

    promise.then(data => {
      this.roleUsers = data
    })

    return promise
  },
  showFile (payload) {
    const promise = FilesService.showById(payload)

    promise.then(data => {
      this.elementFile = data
    })

    return promise
  },
  saveSignatureResource (payload) {
    const promise = FilesService.saveSignatureResource(payload)

    return promise
  },
  resetFile (payload) {
    this.elementFile = payload
  },
  saveFileName (payload) {
    const promise = FilesService.saveFileName(payload)

    return promise
  },
  approveDocument (payload) {
    const promise = FilesService.approveDocument(payload)

    return promise
  },
  documentComments (payload) {
    const promise = FilesService.documentComments(payload)

    return promise
  },
  fileLogByFolder (payload) {
    const promise = FilesService.fileLogByFolder(payload)

    promise.then(data => {
      this.logFiles = data
    })

    return promise
  }
}
